import React from 'react';
import { loadLazyComponent } from '@wix/communities-forum-client-commons';

const MemberCardAsyncLoadable = loadLazyComponent(
  () => import(/* webpackChunkName: "member-card-async-frameless" */ '../member-card'),
  {
    loading: (props) => <div className={props.className}>{props.children}</div>,
  },
);

let hasLoaded = false;
export default class MemberCardAsync extends React.Component {
  state = { shouldRender: hasLoaded };
  renderCard = () => {
    if (this.state.shouldRender) {
      return;
    }
    MemberCardAsyncLoadable.load().then(() => {
      hasLoaded = true;
      this.setState({ shouldRender: true });
    });
  };

  render() {
    const { children, ...rest } = this.props;
    return hasLoaded || this.state.shouldRender ? (
      <MemberCardAsyncLoadable {...rest}>{children}</MemberCardAsyncLoadable>
    ) : (
      <div {...rest} onMouseOver={this.renderCard}>
        {children}
      </div>
    );
  }
}
